<aside class="rounded-2xl border border-secondary-border bg-white p-8">
  <div class="border-b border-secondary-border pb-6">
    <h2 class="text-2xl font-medium text-primary-text">
      {{ 'pages.articlePurchase.summaryTitle' | translate }}
    </h2>
  </div>

  @if (article(); as article) {
    <div class="mt-6 flex flex-col gap-6">
      <div class="flex flex-col gap-3">
        <p class="text-base font-medium text-primary-text">
          {{ article.title }}
        </p>
        <p class="text-sm text-secondary-text">
          {{ article.magazine.title }}
        </p>
      </div>

      <div class="flex flex-col gap-4 text-sm text-primary-text">
        <div class="flex items-start justify-between gap-4">
          <span>{{ 'pages.articlePurchase.summarySubtotal' | translate }}</span>
          <div class="flex flex-col items-end gap-1 text-right">
            @if (studentPricingApplies()) {
              <p>
                <span class="text-secondary-text line-through">
                  {{ regularSubtotal() | currency: 'EUR' }}
                </span>
                <span class="font-medium text-primary-text">
                  {{ subtotal() | currency: 'EUR' }}
                </span>
              </p>
              <span class="text-xs text-secondary-text">
                {{ 'pages.articlePurchase.studentPriceLabel' | translate }}
              </span>
            } @else {
              <span>{{ subtotal() | currency: 'EUR' }}</span>
            }
          </div>
        </div>

        @if (vatAmount(); as vatAmount) {
          <div class="flex items-center justify-between gap-4">
            <span>
              {{
                'pages.articlePurchase.summaryVat'
                  | translate
                    : { rate: article.purchase_price?.taxPercentage ?? 0 }
              }}
            </span>
            <span>{{ vatAmount | currency: 'EUR' }}</span>
          </div>
        }

        <div
          class="border-t border-secondary-border pt-4 text-base font-medium"
        >
          <div class="flex items-center justify-between gap-4">
            <span>{{ 'pages.articlePurchase.summaryTotal' | translate }}</span>
            <span>{{ total() | currency: 'EUR' }}</span>
          </div>
        </div>

        @if (showStudentPricingNotice()) {
          <p
            class="rounded-lg border border-secondary-border bg-secondary-background px-4 py-3 text-sm font-normal text-primary-text"
          >
            {{
              'pages.articlePurchase.studentPricingAutoAppliedNotice'
                | translate
                  : { studentPrice: (studentTotal() | currency: 'EUR') }
            }}
          </p>
        }
      </div>
    </div>
  } @else {
    <div class="mt-6 text-sm text-secondary-text">
      {{ 'pages.articlePurchase.loading' | translate }}
    </div>
  }
</aside>
